import React from 'react';
import type { DividendLegendItem } from '@app-types/performanceDividend';
import './DividendLegend.less';

export interface DividendLegendProps {
  items: DividendLegendItem[];
  nodeId?: string;
}

/**
 * Centered legend row rendered below the Dividend History chart (PD04).
 *
 * Each item is either a colored square swatch ('box') or a horizontal
 * line swatch ('line'), followed by a text label.
 *
 * Figma refs: desktop 3353:29977, mobile 3490:22835.
 */
const DividendLegend: React.FC<DividendLegendProps> = ({ items, nodeId }) => (
  <ul className="dividend-legend" data-node-id={nodeId}>
    {items.map((item) => (
      <li key={item.key} className="dividend-legend__item">
        {item.type === 'box' ? (
          <span
            className="dividend-legend__swatch-box"
            style={{ backgroundColor: item.color }}
            aria-hidden="true"
          />
        ) : (
          <span
            className="dividend-legend__swatch-line"
            style={{ backgroundColor: item.color }}
            aria-hidden="true"
          />
        )}
        <span className="dividend-legend__label">{item.label}</span>
      </li>
    ))}
  </ul>
);

export default DividendLegend;
